import { render, staticRenderFns } from "./CallLogForTel.vue?vue&type=template&id=32740ceb&scoped=true"
import script from "./CallLogForTel.vue?vue&type=script&lang=js"
export * from "./CallLogForTel.vue?vue&type=script&lang=js"
import style0 from "./CallLogForTel.vue?vue&type=style&index=0&id=32740ceb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32740ceb",
  null
  
)

export default component.exports